import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const getOffer = (connectionId, cameraName, droneId) => {
    return handler.get(`webrtc/getoffer?id=${connectionId}&name=${encodeURIComponent(cameraName)}&token=${droneId}`);
};
const setAnswer = (connectionId, droneId, answer) => {
    return handler.post(`webrtc/setanswer?id=${connectionId}&token=${droneId}`, answer);
};
const setIceCandidate = (connectionId, droneId, candidate) => {
    return handler.post(`webrtc/addicecandidate?id=${connectionId}&token=${droneId}`, candidate);
};
const getCameras = (droneId) => {
    return handler.get(`webrtc/getcameras2?token=${droneId}`);
};
const resetCameras = (droneId) => {
    return handler.post(`webrtc/${droneId}/reset-cameras`);
};
export default {
    getOffer,
    setAnswer,
    setIceCandidate,
    getCameras,
    resetCameras,
};
